<template>
    <div>
        <sample-header> </sample-header>
        <loading-indicator v-if="!loaded" message="Please wait"></loading-indicator>
        <div v-if="loaded">
            <router-view></router-view>
        </div>
        <sample-footer> </sample-footer>
    </div>
</template>

<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
import SampleOrder from "@/components/models/SampleOrder";
import LoadingIndicator from "@/components/layout/LoadingIndicator";

function initializeChoices(program) {
  return {
    design: program.designChoices,
    material: program.materialChoices,
    treatment: program.treatmentChoices,
    photochromic: program.photochromicChoices,
    lensDesignLabel: program.lensDesignLabel,
    lensMaterialLabel: program.lensMaterialLabel,
    lensTreatmentLabel: program.lensTreatmentLabel,
    lensPhotochromicLabel: program.lensPhotochromicLabel
  };
}

import Vue from "vue";

export default {
  props: ["couponCode", "programChoice"],
  components: { SampleHeader, SampleFooter, LoadingIndicator },
  data() {
    return {
      sampleobject: null,
      termsContent: null,
      choices: null,
      loaded: false,
      program: null
    };
  },
  methods: {
    handleError() {
      this.$router.replace("/error/");
    },
    loadCoupon(apiPath) {
      axios
        .get(apiPath)
        .then(response => {
          if (response.data.status.statusCode > 0) {
            this.handleError("invalid code");
          }

          this.sampleobject = new SampleOrder(
            response.data,
            this.programChoice,
            false
          );
          if (response && (response.data.programDetails.programType === "Employee" || response.data.programDetails.programType === "SalesRep")) {
            this.applyError(interpretStatus("NOT_FOUND"));
          }
          this.choices = initializeChoices(response.data.programDetails);
          this.program = response.data.programDetails;
          this.loadTerms();
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    loadTerms() {
      axios
        .get(Vue.config.HOST_URL + this.sampleobject.termsPageName, {
          responseType: "text"
        })
        .then(response => {
          this.termsContent = response.data;
          this.loaded = true;
        })
        .catch(error => {
          this.handleError(error);
        });
    }
  },
  created() {
    if (!this.programChoice) {
      this.loadCoupon(`/coupon/${this.couponCode}`);
    } else {
      this.loadCoupon(
        `/coupon/${this.couponCode}/programChoice/${this.programChoice}`
      );
    }
  }
};
</script>
